import axios from "axios"
import { useDefaultAttachmentsApiForControllerRoute } from "."

export function useChatAttachmentApi() {
  const defaultAPI = useDefaultAttachmentsApiForControllerRoute("chats")

  return {
    ...defaultAPI,
    addProfilePictureForChat: function (file: File, chatId: number) {
      const formData = new FormData()
      formData.append("file", file, file.name)

      return axios.post(
        `${defaultAPI.baseUrl}/set-profile-picture?chatId=${chatId}`,
        formData
      )
    },
    deleteProfilePictureForChat: function (chatId: number) {
      return axios.post(`${defaultAPI.baseUrl}/delete-profile-picture`, {
        chatId,
      })
    },
  }
}
